module.exports = __webpack_public_path__ + "img/klingelbeutel_on_background_black.33425521.jpg";